import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

export type ToastKind = "success" | "error" | "info";

export interface ToastMessage {
  id: number;
  kind: ToastKind;
  message: string;
}

@Injectable({ providedIn: "root" })
export class ToastService {
  private nextId = 1;
  private readonly messagesSubject = new BehaviorSubject<ToastMessage[]>([]);
  readonly messages$ = this.messagesSubject.asObservable();

  success(message: string) {
    this.push("success", message);
  }

  error(message: string) {
    this.push("error", message);
  }

  info(message: string) {
    this.push("info", message);
  }

  dismiss(id: number) {
    this.messagesSubject.next(
      this.messagesSubject.value.filter((message) => message.id !== id),
    );
  }

  private push(kind: ToastKind, message: string) {
    const toast: ToastMessage = { id: this.nextId++, kind, message };
    this.messagesSubject.next([...this.messagesSubject.value, toast]);
    window.setTimeout(() => this.dismiss(toast.id), 3800);
  }
}
